<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout wrap>
      <v-flex md12 sm12 lg12>
        <v-card class="elevation-12">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>Campaigns</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-select
              v-model="searchColumn"
              :items="filteredSearchColumn"
              item-text="text"
              item-value="value"
              label="Select column"
              return-object
              single-line
              hide-details
              class="mr-3"
              @input="customSearch"
            ></v-select>
            <v-text-field
              v-model="tableSearch"
              append-icon="mdi-table-search"
              label="Search..."
              single-line
              hide-details
              @input="customSearch"
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-checkbox
              v-model="showTerminated"
              label="Show terminated"
              @change="getCampaigns"
            ></v-checkbox>
            <v-spacer></v-spacer>
            <v-btn
              class="ma-2"
              outlined
              color="white"
              v-if="loggedUser.role === '1'"
              @click.stop="rightDrawer = !rightDrawer"
              >New Campaign</v-btn
            >
          </v-toolbar>
          <v-card-text>
            <v-data-table
              :headers="tableHeaders"
              :items="tableData"
              :options.sync="options"
              :loading-text="'Loading Campaigns...'"
              :loading="loading"
              class="elevation-1"
              :must-sort="true"
              :footer-props="{
                'items-per-page-options': [5, 10, 15, 20, 30, 50, 100],
              }"
              :items-per-page="50"
            >
            <template v-slot:item.status_name="{ item }">
                <v-chip :color="getStatusColor(item.status)" dark>{{
                  item.status_name
                }}</v-chip>
              </template>
              <template v-slot:item.is_budget_fixed="{ item }">
                <v-chip :color="getStatusColor(item.is_budget_fixed)" dark>{{
                  item.is_budget_fixed
                }}</v-chip>
              </template>
              <template v-slot:item.name="{ item }">
                <a @click="goToCampaign(item)" dark>{{ item.name }}</a>
              </template>
              <template v-slot:item.intervention_areas="{ item }">
                <div
                  class="body-2"
                  v-for="(area, index) in item.intervention_areas"
                  :key="index"
                >
                  {{ area }}
                </div>
              </template>
              <template v-slot:item.campaign_attributes.start_date="{ item }">{{
                item.campaign_attributes.start_date | formatDateSmall
              }}</template>
              <template v-slot:item.campaign_attributes.end_date="{ item }">{{
                item.campaign_attributes.end_date | formatDateSmall
              }}</template>
              <template v-slot:item.action="{ item }">
                <v-icon
                  small
                  class="mr-2"
                  @click="$router.push({ path: 'campaigns/' + item.id })"
                  >mdi-square-edit-outline</v-icon
                >
                <v-icon small @click="deleteCampaign(item.id)"
                  >mdi-delete</v-icon
                >
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-navigation-drawer
        absolute
        right
        temporary
        width="60%"
        height="100vh"
        style="margin-top: -64px"
        v-model="rightDrawer"
      >
        <v-flex md12 sm12 lg12 :key="dataLoaded">
          <h1>{{ campaignDetails.formTitle }}</h1>
          <v-form ref="newCampaign" v-model="formValid">
            <v-form-base
              v-bind:value="campaignDetails.data"
              v-bind:schema="newCampaignSchema"
            />
          </v-form>
          <v-btn color="secondary" outlined @click="rightDrawer = false"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            @click="addCampaign(campaignDetails.data)"
            :disabled="!formValid"
            >Create Campaign</v-btn
          >
        </v-flex>
      </v-navigation-drawer>
    </v-layout>
  </v-container>
</template>

<script>
import apiService from '../services'
import { mapState } from 'vuex'
import moment from 'moment'

// Rules
const formRules = {
  required: (field) => (v) => (v && v.length > 0) || `${field} is required`,
  requiredSelect: (field) => (v) => v || `${field} is required`,
  validEmail: (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid'
}
const budgetOptions = [
  {
    label: 'Budget Fisso',
    value: 1
  },
  {
    label: 'Budget Variabile',
    value: 2
  }
]

const mechanismOptions = [
  {
    label: 'Votes',
    value: 1
  },
  {
    label: 'Donations',
    value: 2
  },
  {
    label: 'Giftcard',
    value: 4
  }
]
const donationFactorOptions = ['%', 'Fixed']

export default {
  watch: {
    options: {
      handler () {
        this.getCampaigns()
      },
      deep: true
    },
    dialog (val) {
      val || this.closeModal()
    }
  },
  computed: {
    ...mapState('init', ['campaignStatus', 'interventionAreas']),
    filteredSearchColumn () {
      // Table headers are also used for search porpuses
      // Filter out action header
      return this.tableHeaders.filter((item) => item.value !== 'action')
    },
    ...mapState({
      auth: 'auth',
      alerts: (state) => state.alert.snackbars
    }),
    loggedIn () {
      return this.auth.loggedIn
    },
    loggedUser () {
      return this.auth.user || null
    },

    newCampaignSchema () {
      let interventionAreasList = this.interventionAreas

      let schema = {
        name: {
          type: 'text',
          label: 'Name',
          flex: 12,
          rules: [formRules.required('Name')]
        },

        description: {
          type: 'textarea',
          label: 'Description',
          flex: 12
        },

        intervention_areas: {
          type: 'select',
          label: 'Intevention Areas',
          items: interventionAreasList,
          returnObject: false,
          itemValue: 'id',
          itemText: 'name',
          multiple: true,
          rules: [(v) => !!v || 'Intevention Area is required'],
          flex: { xs: 12, sm: 6 }
        },

        // Divider

        durationRange: {
          type: 'text',
          ext: 'date',
          color: 'primary',
          locale: 'en-US',
          prependIcon: 'mdi-calendar',
          label: 'Duration',
          noTitle: true,
          range: true,
          flex: { xs: 12, sm: 6, md: 6 }
        },

        is_budget_fixed: {
          type: 'select',
          label: 'Budget type',
          items: budgetOptions,
          itemText: 'label',
          itemValue: 'value',
          rules: [(v) => !!v || 'Budget type is required'],
          flex: { xs: 12, sm: 6 }
        },

        budget: {
          type: 'number',
          label: 'Budget',
          min: '0',
          hidden: this.campaignDetails.data.is_budget_fixed !== 1,
          flex: { xs: 12, sm: 6 }
        },

        mechanism: {
          type: 'select',
          label: 'Mechanism',
          clearable: false,
          items: mechanismOptions,
          itemText: 'label',
          itemValue: 'value',
          returnObject: false,
          rules: [(v) => !!v || 'Mechanism is required'],
          flex: { xs: 12, sm: 6, md: 6 }
        },

        cashback_amount: {
          type: 'number',
          label: 'Donation Amount',
          hidden: this.campaignDetails.data.mechanism !== 2,
          flex: { xs: 12, sm: 6 }
        },
        cashback_factor: {
          type: 'select',
          label: 'Donation Factor',
          hidden: this.campaignDetails.data.mechanism !== 2,
          clearable: false,
          items: donationFactorOptions,
          returnObject: false,
          flex: { xs: 12, sm: 6 }
        },
        is_leading: {
          type: 'checkbox',
          color: 'primary',
          label: 'Generate Leads',
          flex: { xs: 12, md: 12 }
        }
      }

      return schema
    }
  },
  // eslint-disable-next-line vue/no-unused-components
  components: {
    VFormBase: () => import('vuetify-form-base')
  },
  data () {
    return {
      // Ricerca nella tabella
      dataLoaded: false,
      searchColumn: '',
      tableSearch: '',
      tableSearchTimeout: false,
      rightDrawer: false,
      showTerminated: false,

      // Campaigns table
      tableHeaders: [
        {
          text: 'Campaign',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        {
          text: 'Intervention areas',
          align: 'left',
          sortable: false,
          value: 'intervention_areas'
        },
        {
          text: 'Budget',
          align: 'left',
          sortable: true,
          value: 'budget'
        },
        {
          text: 'Fiixed budget?',
          align: 'left',
          sortable: true,
          value: 'is_budget_fixed'
        },
        {
          text: 'Start date',
          align: 'left',
          sortable: true,
          value: 'date_start'
        },
        {
          text: 'End date',
          align: 'left',
          sortable: true,
          value: 'date_end'
        },
        {
          text: 'Mechanism',
          align: 'left',
          sortable: true,
          value: 'mechanism'
        },
        {
          text: 'Status',
          value: 'status_name',
          sortable: true
        },
        { text: 'Actions', value: 'action', sortable: false }
      ],
      options: {},
      totalData: 0,
      tableData: [],
      loading: true,

      // New campaign form
      formValid: true,
      campaignDetails: {
        formTitle: 'New campaign',
        data: {
          name: '',
          intervention_areas: [],
          description: ''
        }
      }
    }
  },

  methods: {
    // GET Campaigns
    getCampaigns () {
      this.loading = true

      const { sortBy, sortDesc, page, itemsPerPage } = this.options

      // Setup search filter extending data-table componet option object
      let filter = {}
      filter.sort_by = sortBy[0] || null
      filter.page = page
      filter.limit = itemsPerPage
      filter.descending = sortDesc[0] || null

      filter.search_filter =
        this.tableSearch !== '' ? this.searchColumn.value : ''
      filter.search_value = this.tableSearch || ''

      if (
        filter.search_filter === 'date_start' ||
        filter.search_filter === 'date_end'
      ) {
        filter.search_value = moment(this.tableSearch, 'DD-MM-YYYY').format(
          'YYYY-MM-DD'
        )
      }

      // GET on global entities search API endpoint
      apiService
        .fetchData('campaigns', filter)
        .then((data) => {
          setTimeout(() => {
            console.log('GETTING DATA')
            this.tableData = data.filter(campaign => {
              console.log(campaign)
              if (!this.showTerminated) {
                return campaign.status !== 3
              } else {
                return campaign
              }
            })
            this.tableData.map((item) => {
              item.date_start
                ? (item.date_start = moment(item.date_start).format(
                  'DD-MM-YYYY'
                ))
                : (item.date_start = '')
              item.date_end
                ? (item.date_end = moment(item.date_end).format('DD-MM-YYYY'))
                : (item.date_end = '')
              return item
            })

            this.tableData.forEach(function (item) {
              item.intervention_areas = item.intervention_areas.map(
                (x) => x.name
              )
            })

            this.totalData = data.length
            this.loading = false
          }, 800)
        })
        .catch((error) => {
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: `Cannot get campaigns ${error}`
          })
          // Close edit menu
          this.editContact = !this.editContact
        })
    },

    // This will trigger when either of the search inputs is changed
    customSearch () {
      if (this.searchColumn !== '') {
        // Stop timeout to prevent search from firing while user is still typing
        clearTimeout(this.tableSearchTimeout)
        // Set a timeout to fire search after the user has stopped typing
        this.tableSearchTimeout = setTimeout(() => {
          this.getCampaigns()
        }, 800)
      }
    },
    validateForm () {
      return this.$refs.newCampaign.validate()
    },

    goToCampaign (item) {
      if (item.mechanism === 'giftcard') { // non so se va bene cosi
        this.$router.push({
          path: 'campaigns/gifcard/' + item.id,
          params: { id: item.id }
        })
      } else {
        this.$router.push({
          path: 'campaigns/' + item.id,
          params: { id: item.id }
        })
      }
    },

    addCampaign (data) {
      if (this.validateForm()) {
        let newCampaignData = data

        // Check if poth start date and end date have been selected

        if (newCampaignData.durationRange.length === 2) {
          // Sort in ascending direction dates so that start date is always the first element of the array durationRange
          const dateRange = newCampaignData.durationRange.sort()
          newCampaignData.date_start = moment(dateRange[0]).format(
            'YYYY-MM-DD'
          )

          newCampaignData.date_end = moment(dateRange[1]).format('YYYY-MM-DD')
          delete newCampaignData.durationRange
        } else {
          // Campaign start and end date have not been set, exit process
          return
        }

        if (newCampaignData.is_budget_fixed === 1) {
          newCampaignData.is_budget_fixed = true
        } else {
          newCampaignData.is_budget_fixed = false
          newCampaignData.budget = 0
        }

        newCampaignData.status = 1

        // GET on global entities search API endpoint
        apiService
          .newCampaign(newCampaignData)
          .then((response) => {
            const data = {
              campaign: response.campaign_id
            }
            apiService.createSurvey(data).catch((error) => {
              console.log(error)
            })
            this.rightDrawer = false

            this.getCampaigns()

            this.$refs.newCampaign.reset()

            this.$store.dispatch('alert/showSnackbar', {
              color: 'success',
              text: `Campaign created`
            })
          })
          .catch((error) => {
            console.log(error)
            this.$store.dispatch('alert/showSnackbar', {
              color: 'error',
              text: `Error during campaign creation.`
            })
            // Close edit menu
            this.editContact = !this.editContact
          })
      }
    },

    // TO DO these methods will be implemented after first fase of development is completed - Riccardo Cosentino 04052020
    deleteCampaign (item) {
      apiService
        .deleteCampaign(item)
        .then((data) => {
          this.$store.dispatch('alert/showSnackbar', {
            color: 'success',
            text: 'Campaign deleted'
          })
          this.getCampaigns()
        })
        .catch((error) => {
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: `${error.message}`
          })
          // Close edit menu
          this.editContact = !this.editContact
        })
    },

    // Setup mock of statuses color since definitive set of statuses has not been provided yet
    getStatusColor (status) {
      if (status === 1 || status === true) return 'green'
      else if (status === 2 || status === false) return 'red'
      else return 'gray'
    }
  }
}
</script>
